var s = Object.defineProperty;
var a = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
var d = (r, p, o) => p in r ? s(r, p, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[p] = o, f = (r, p) => {
  for (var o in p || (p = {}))
    i.call(p, o) && d(r, o, p[o]);
  if (a)
    for (var o of a(p))
      u.call(p, o) && d(r, o, p[o]);
  return r;
};
var e = (r, p) => {
  var o = {};
  for (var m in r)
    i.call(r, m) && p.indexOf(m) < 0 && (o[m] = r[m]);
  if (r != null && a)
    for (var m of a(r))
      p.indexOf(m) < 0 && u.call(r, m) && (o[m] = r[m]);
  return o;
};
import { jsx as G } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import { G as n } from "../../Group-CbE78j-X.js";
const x = l((c, m) => {
  var t = c, {
    "data-plum-id": r,
    className: p
  } = t, o = e(t, [
    "data-plum-id",
    "className"
  ]);
  return /* @__PURE__ */ G(
    n,
    f({
      ref: m,
      className: p,
      "data-plum-id": r
    }, o)
  );
});
x.displayName = "Group";
export {
  x as Group
};
